import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, filter }) =>
    present(
      repository
        .getLists(project, filter)
        .then((lists) => ({ lists, project, filter }))
        .catch((error) => Promise.reject({ error, project, filter })),
    );
}

export type { Interactor };

export { createInteractor };
